import { useState } from "react";
import { Navigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../lib/auth";
import ContentEditor from "../components/admin/ContentEditor";
import { CommunityTab, EnquiriesTab } from "../components/admin/Tabs";
import { AppsTab } from "../components/admin/AppsTab";

const TABS = [
  { id: "pages", label: "Page Content" },
  { id: "apps", label: "Apps" },
  { id: "enquiries", label: "Enquiries" },
  { id: "community", label: "Community" },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("pages");

  if (user === null) return <div className="min-h-screen bg-ink" />;
  if (user === false) return <Navigate to="/admin/login" replace />;

  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-ink pt-28 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-10">
          <div>
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-mauve mb-2">Studio CMS</p>
            <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight text-silver">Welcome, {user.name}</h1>
          </div>
          <button
            data-testid="admin-logout-button"
            onClick={logout}
            className="inline-flex items-center gap-2 border border-white/15 text-zinc-200 px-5 py-2.5 text-xs tracking-[0.2em] uppercase hover:text-white hover:border-mauve/50 transition-colors duration-200"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
        <div className="flex gap-2 mb-10 border-b border-white/10 pb-px">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={`admin-tab-${t.id}`}
              onClick={() => setTab(t.id)}
              className={`px-5 py-3 text-xs tracking-[0.15em] uppercase font-medium border-b-2 transition-colors duration-200 ${
                tab === t.id ? "border-mauve text-mauve-light" : "border-transparent text-zinc-300 hover:text-white"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
        {tab === "pages" && <ContentEditor />}
        {tab === "apps" && <AppsTab />}
        {tab === "enquiries" && <EnquiriesTab />}
        {tab === "community" && <CommunityTab />}
      </div>
    </div>
  );
}
